import { getMerchantByOrganisationId } from "@api";
import { Logo, PageLoader, ProgressBar } from "@components";
import { usePostHogIdentify } from "@hooks";
import { useEffect, useState } from "react";
import { Outlet, useMatches, useNavigate, useParams } from 'react-router-dom';

const PayTo = () => {
  let { orgId } = useParams();
  const matches = useMatches();
  const navigate = useNavigate();
  const routeId = matches[matches.length - 1].id;

  const [merchant, setMerchant] = useState(null);
  const [payment, setPayment] = useState(null);
  const [paymentParameters, setPaymentParameters] = useState(null);
  const [methodStepData, setMethodStepData] = useState();

  // Use PostHog identification hook  
  // For open payment link, we'll use customer email as ID since there's no customer ID
  
  // usePostHogIdentify({
  //   customerId: paymentParameters?.customerEmail,
  //   customerName: paymentParameters?.customerName,
  //   merchantId: paymentParameters?.merchantId,
  //   merchantName: merchant?.name,
  // }, !!paymentParameters);

  const progressMap = {
    "opl-paymentdetails": "20%",
    "opl-choosepaymentmethod": "40%",
    "opl-confirmpaybybank": "60%",
    "opl-success": "full",
    "opl-processing": "80%",
  };

  useEffect(() => {
    const loadMerchant = async () => {
      const merchantData = await getMerchantByOrganisationId(orgId);
      setMerchant(merchantData);
    }

    loadMerchant();
  }, []);

  // todo, 
  return (merchant ?
    <div className="lg:h-dvh lg:flex lg:flex-col">
      <div className="sticky top-0">
        <div className="bg-white flex items-center justify-center py-2 h-[68px]">
          <Logo merchant={merchant} />
        </div>
        <ProgressBar merchant={merchant} width={progressMap[routeId]} />
      </div>
      <Outlet context={{
        merchant,
        setMethodStepData,
        setPaymentParameters,
        paymentParameters,
        methodStepData,
        setPayment,
        payment
      }} />
    </div> : <PageLoader />);
}

export default PayTo;